<script lang="ts" setup>
interface Props {
    loading?: boolean;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    loading: false,
    disabled: false,
});
</script>

<template>
    <button :class="{ 'pr-[50px] is-loading': loading, 'opacity-50 cursor-not-allowed': disabled }" :disabled="disabled || loading" type="submit">
        <slot></slot>
    </button>
</template>

<style scoped>
button {
    @apply bg-white text-brown-200 relative font-helv font-bold text-center leading-[24px] h-[48px] px-[48px] border border-white hover:bg-none hover:text-white;
    transition: all 0.25s ease-in-out;
}

.is-loading::after {
    content: "";
    position: absolute;
    width: 1rem;
    height: 1rem;
    top: calc(50% - 0.5rem);
    right: 20px;
    border-radius: 2em;
    border-color: transparent transparent #fff #fff;
    border-style: solid;
    border-width: 0.15em;
    animation: spinner-rotation 0.75s infinite;
    animation-timing-function: linear;
}

@keyframes spinner-rotation {
    to {
        transform: rotate(360deg);
    }
}
</style>
